// popstate scroll functions

import { isPlatformBrowser } from '@angular/common'

/**
 * scroll modal to terms of use like links after
 * the popstate event
 */
function scrollFormToLinks(that, document) {
  if (!isPlatformBrowser(this.platformId)) {
    return;
  }
  const ulList = document.getElementById('linkList')
  if (ulList) {
    that.logger.info(ulList)
    that.logger.info('modal form scroll to links')
    const alignToTop = true
    ulList.scrollIntoView(alignToTop)
  }
}

/**
 *  check popstate event trigger
 */
export function getScrollBotToLinks(that, document) {
    const current = that.pageNavigationService.getCurrentState()
    // our case or restoring
    if (current && current.trigger === 'popstate') {
      const scrollKey = 'scrollMobileTo'
      const formLinks = 'form-links'
      const linkValue = that.modalStateService.getFromLocalStorage(scrollKey)
      if (linkValue === formLinks) {
        scrollFormToLinks(that, document)
        // clear value
        that.modalStateService.pushToLocalStorage(scrollKey, null)
      }
    }
  }

/**
 * create popstate scroll data to local storage
 */
export function setScrollBotToLinks(that, document) {
    const scrollKey = 'scrollMobileTo'
    const formLinks = 'form-links'
    that.modalStateService.pushToLocalStorage(scrollKey, formLinks)
  }
